import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://media-exp1.licdn.com/dms/image/C4E1BAQHmTHaDGgSeWA/company-background_10000/0/1547513228929?e=2159024400&v=beta&t=F3UACfiwRqIHHB4QtRrf4bntan1EEQ3Q6LCkYUM-1FQ"
          alt=""
          />
          <div className="home__row">
              <Product 
               id="12321341"
               title="Books for free"
               number="The number of the seller: 062-***-****"
               name="The name of te seller: Eun Dae Kim"
               price={0}
               rating={3}
               image="https://i.pinimg.com/564x/a5/fb/96/a5fb9624ef9138872fdbe0a965330aeb.jpg"
              />
              <Product 
               id="49538094"
               title="Royal Milk Tea"
               number="The number of seller: 062-***-****"
               name="The name of the seller: Ji Hyun Jung"
               price={7000}
               rating={5}
               image="https://i.pinimg.com/564x/a0/33/73/a03373b70fa2690b890c54329b694fdc.jpg"
              />
            </div>

          <div className="home__row">
              <Product 
              id="4903850"
              title="Pastel Clock"
              number="The number of seller: 062-***-****"
              name="The name of the seller: Min-Jee Ban"
              price={15000}
              rating={2}
              image="https://data.whicdn.com/images/346741144/original.jpg"
            />
              <Product 
              id="23445930"
              title="A Laundry Basket"
              number="The number of seller: 062-***-****"
              name="The name of the seller: Yun-Hee Jwa"
              price={3500}
              rating={5}
              image="https://i.pinimg.com/originals/32/a8/1c/32a81c117e5a877e6f3a5efcf3aeecc3.jpg"
              />
              
            </div>

          <div className="home__row">

              <Product 
              id="3254354345"
              title="White Wood Hangers"
              number="The number of seller: 062-***-****"
              name="The name of the seller: Myo Dae Kang"
              price={20000}
              rating={5}
              image="https://i.pinimg.com/originals/8b/25/d2/8b25d2d371fcb54c730380c0fd13726a.jpg"
              />
              
              <Product 
              id="90829332"
              title="Pearl Boba Tea Mini Fridge"
              number="The number of seller: 062-***-****"
              name="The name of the seller: Son Iseul Sim"
              price={100000}
              rating={5}
              image="https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1620917760-wmh3al-q-2000x-1620917711.jpg?crop=1.00xw:0.668xh;0,0.286xh&resize=480:*"
              />
              </div>
          </div>
        </div>
  );
}
export default Home;